import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    user: null,
    token: null,
    refreshToken: null,
    permissions: [],
    modules: [],
    clinic_id: null,
    clinicBranding: null,
    isImpersonating: false,
    impersonatedClinicName: null,
    ownedClinics: [],
  },
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload.userData || null;
      // Demo-session flag: mock data is enabled ONLY for demo accounts.
      // Set for demo logins, CLEARED for every real user → real users never see mock.
      try {
        if (action.payload.userData?.is_demo) {
          sessionStorage.setItem("vistaarDemo", "1");
        } else {
          sessionStorage.removeItem("vistaarDemo");
        }
      } catch (e) { /* ignore */ }
      state.token = action.payload.token || null;
      state.refreshToken = action.payload.refreshToken || null;
      state.permissions = action.payload.permissions || [];
      state.modules = action.payload.modules || [];
      state.clinic_id = action.payload.userData?.clinic_id || null;
      state.isImpersonating = false;
      state.impersonatedClinicName = null;
      state.ownedClinics = action.payload.ownedClinics || [];
    },
    setClinicBranding(state, action) {
      state.clinicBranding = action.payload;
    },
    logout(state) {
      try { sessionStorage.removeItem("vistaarDemo"); } catch (e) { /* ignore */ }
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.permissions = [];
      state.modules = [];
      state.clinic_id = null;
      state.clinicBranding = null;
      state.isImpersonating = false;
      state.impersonatedClinicName = null;
    },
    updateProfile(state, action) {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    startImpersonation(state, action) {
      try { sessionStorage.removeItem("vistaarDemo"); } catch (e) { /* ignore */ }
      state.isAuthenticated = true;
      state.user = action.payload.userData || null;
      state.token = action.payload.token || null;
      state.refreshToken = action.payload.refreshToken || null;
      state.permissions = action.payload.permissions || [];
      state.modules = action.payload.modules || [];
      state.clinic_id = action.payload.userData?.clinic_id || null;
      state.isImpersonating = true;
      state.impersonatedClinicName = action.payload.clinicName || null;
    },
  },
});

export const { login, logout, updateProfile, setClinicBranding, startImpersonation } = authSlice.actions;
export default authSlice.reducer;
